module.exports = __webpack_public_path__ + "static/media/logo.aadb7b19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 292
// module chunks = 0